/**
 * Russian status messages displayed below the mic button.
 */

import { FC } from "react";
import { ConnectionState } from "../mic-button/MicButton";
import "./status-text.scss";

interface StatusTextProps {
  state: ConnectionState;
  isSpeaking: boolean;
}

const STATUS_MESSAGES: Record<string, string> = {
  disconnected: "Нажмите, чтобы поговорить",
  connecting: "Подключение...",
  listening: "Галена слушает...",
  speaking: "Галена говорит...",
};

const StatusText: FC<StatusTextProps> = ({ state, isSpeaking }) => {
  let message: string;
  if (state !== "connected") {
    message = STATUS_MESSAGES[state];
  } else {
    message = isSpeaking ? STATUS_MESSAGES.speaking : STATUS_MESSAGES.listening;
  }

  return <p className="status-text">{message}</p>;
};

export default StatusText;
